import { render, staticRenderFns } from "./XSelectUnidadAdministrativa.vue?vue&type=template&id=6ace32fc&"
import script from "./XSelectUnidadAdministrativa.vue?vue&type=script&lang=js&"
export * from "./XSelectUnidadAdministrativa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports